import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchServiceForms(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/service-forms', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteServiceForm(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/service-forms/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
